module.exports = __webpack_public_path__ + "static/media/oxygen mall render 01.8e47b651.webp";